import {Node} from '@tiptap/core'
import {VueRenderer} from '@tiptap/vue-2';
import Suggestion from '@tiptap/suggestion';
import {PluginKey} from 'prosemirror-state';
import {uniqueId} from 'lodash';
import SuggestionsDropdown from '../contentEditor/SuggestionsDropdown';
import tippy from 'tippy.js';
import {tr} from "date-fns/locale";

function find(haystack, needle) {
  return String(haystack).toLocaleLowerCase().includes(String(needle).toLocaleLowerCase());
}

function createSuggestionPlugin({
                                  editor,
                                  char,
                                  dataSource,
                                  search,
                                  nodeType,
                                  nodeProps = {},
                                }) {

  return Suggestion({
    editor,
    char,
    pluginKey: new PluginKey(uniqueId('suggestions')),

    command: ({editor: tiptapEditor, range, props}) => {
      tiptapEditor
          .chain()
          .focus()
          .insertContentAt(range, [{type: nodeType, attrs: props}])
          .run();
    },

    async items({query}) {
      try {
        return await dataSource(search(query))
      } catch (error) {
        console.log(error)
      } finally {
      }
    },

    render: () => {
      let component;
      let popup;

      return {
        onStart: (props) => {
          component = new VueRenderer(SuggestionsDropdown, {
            propsData: {
              ...props,
              char,
              nodeType,
              nodeProps,
            },
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            theme: 'suggestion',
            content: component.element,
            showOnCreate: true,
            interactive: true,
            size: "small",
            trigger: 'manual',
            placement: 'bottom-start',
          });
        },

        onBeforeUpdate(props) {
          console.log("onBeforeUpdate")
          popup?.[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onUpdate(props) {
          component.updateProps(props);
          if (!props.clientRect) {
            return;
          }
          popup?.[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            popup?.[0].hide();
            return true;
          }
          return component.ref?.onKeyDown(props);
        },

        onExit() {
          popup?.[0].destroy();
          component.destroy();
        },
      };
    },
  });
}


export default Node.create({
  name: 'suggestions',
  addOptions() {
    return {
      ...this.parent?.(),
      usersSuggestion: {
        dataSource: Function,
      },
      filesSuggestion: {
        dataSource: Function,
      },
    }
  },

  addProseMirrorPlugins() {
    return [
      createSuggestionPlugin({
        editor: this.editor,
        char: '@',
        dataSource: (query) => this.options.usersSuggestion.dataSource(query),
        nodeType: 'reference',
        nodeProps: {
          className: 'suggestions',
          referenceType: 'user',
        },
        search: (query) => ({
                              firstName,
                              lastName,
                              username
                            }) => find(firstName, query) || find(lastName, query) || find(username, query)
      }),
      createSuggestionPlugin({
        editor: this.editor,
        char: '#',
        dataSource: (query) => this.options.filesSuggestion.dataSource(query),
        nodeType: 'reference',
        nodeProps: {
          className: 'suggestions',
          referenceType: 'file'
        },
        search: (query) => ({name}) => find(name, query)
      }),
    ]
  },
})
